import { useEffect, useState, useCallback, useRef } from "react";
import { getPaginatedGenericRQScoringConfigs } from "../services/scoringService";

interface IuseFetchPaginatedGenericRQScoringConfigs {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  page: any;
  pSize: any;
  searchFilterData?: any;
}

const useFetchPaginatedGenericRQScoringConfigs = ({
  setIsLoading,
  page,
  pSize,
  searchFilterData,
}: IuseFetchPaginatedGenericRQScoringConfigs) => {
  const [data, setData] = useState<any>([]);
  const abortControllerRef = useRef<AbortController | null>(null);

  const fetchData = useCallback(async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    setIsLoading(true);
    try {
      const statusFilter = searchFilterData?.status_filter;
      const isActive =
        statusFilter === "Active"
          ? true
          : statusFilter === "Inactive"
            ? false
            : undefined;
      const genericResearchQueryId = searchFilterData?.generic_research_query_id
        ? Number(searchFilterData.generic_research_query_id)
        : undefined;
      const result = await getPaginatedGenericRQScoringConfigs({
        page,
        pSize,
        genericResearchQueryId,
        isActive,
      });
      setData(result);
    } catch (err: any) {
      if (err.name !== "AbortError") {
        setData([]);
      }
    } finally {
      setIsLoading(false);
    }
  }, [page, pSize, setIsLoading, searchFilterData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return [data, fetchData];
};

export default useFetchPaginatedGenericRQScoringConfigs;

